export default __webpack_public_path__ + "static/harvard-logo-b54f90cb3ceceeff4489f795f960d66a.png";